export default "__VITE_ASSET__BcjLPsur__"